export default function About() {
  return (
    <section id="about" className="py-24 bg-gradient-to-b from-amber-50 to-orange-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div>
            <p className="text-teal-500 font-semibold text-sm uppercase tracking-wider mb-4">
              WHO WE ARE
            </p>
            <h2 className="text-5xl font-bold mb-6 leading-tight">
              Building Trust Through{' '}
              <span className="text-teal-500 font-serif italic">Excellence & Dedication</span>
            </h2>
            
            <div className="space-y-4 text-gray-600 leading-relaxed text-base">
              <p>
                Abu Ayaan Services is a premier cleaning and staff deployment company in the Kingdom of Bahrain. We specialize in deploying skilled professionals directly at client premises according to their specific requirements. We attribute high levels of customer satisfaction to our unsurpassed implementation of individual attention, selective service, and our non-complacent workmanship and staff supplied and applied to each task.
              </p>
              <p>
                Our contract-based model allows you to have dedicated staff members working at your location - whether you need helpers, office boys, or cleaners. We provide flexible daily and yearly contracts tailored to your business needs.
              </p>
              <p>
                The company's strategic partnership in the area of Cleaning, Staff Deployment, Assistance along with Transport & Accommodation services for clients is based on its acute understanding of the opportunities which exist within these critical sectors.
              </p>
              <p>
                Abu Ayaan Services aims to build fair, equitable and sustainable beneficial trade platforms that will contribute to effective and sustainable beneficiation of resources. The better the quality of the support services, higher will be the business growth.
              </p>
            </div>
          </div>
          
          <div className="grid grid-cols-2 gap-4">
            <div className="rounded-2xl overflow-hidden shadow-lg h-64">
              <img 
                alt="Abu Ayaan Services Staff in Uniform" 
                className="w-full h-full object-cover object-top" 
                src="https://public.readdy.ai/ai/img_res/bc8e42683869adcb7c4ea8970019c269.jpg"
              />
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg h-64">
              <img 
                alt="Deep Cleaning Service" 
                className="w-full h-full object-cover object-top" 
                src="https://readdy.ai/api/search-image?query=professional%20worker%20performing%20deep%20cleaning%20service%20in%20commercial%20building%20using%20modern%20cleaning%20equipment%20and%20chemicals%20scrubbing%20floor%20with%20machine%20wearing%20Abu%20Ayaan%20uniform%20detailed%20cleaning%20work%20in%20progress&width=400&height=500&seq=deep-cleaning-001&orientation=portrait"
              />
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg h-64">
              <img 
                alt="Loading and Unloading Helpers" 
                className="w-full h-full object-cover object-top" 
                src="https://readdy.ai/api/search-image?query=professional%20helpers%20and%20workers%20loading%20and%20unloading%20boxes%20and%20materials%20in%20warehouse%20or%20office%20building%20wearing%20Abu%20Ayaan%20Services%20uniform%20teamwork%20moving%20equipment%20and%20supplies%20efficient%20logistics%20work&width=400&height=500&seq=helpers-loading-001&orientation=portrait"
              />
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg h-64">
              <img 
                alt="Office Boy Service" 
                className="w-full h-full object-cover object-top" 
                src="https://readdy.ai/api/search-image?query=professional%20office%20boy%20in%20Abu%20Ayaan%20Services%20uniform%20providing%20office%20support%20services%20in%20modern%20corporate%20office%20carrying%20documents%20and%20assisting%20with%20office%20tasks%20neat%20and%20professional%20appearance%20helpful%20staff%20member&width=400&height=500&seq=office-boy-001&orientation=portrait"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
